/** Handle the Navigation display logic for the home page
 * Check the home page; get the param and display nav in the home page
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Action
import { switchContentToggle } from '../../contactUs/actions/action-content-toggle';

// Container
import ContentToggle from './ContentToggle';
import NavDropDown from './NavDropDown';

// Helpers.
import Page from '../../lib/page';
import { getHomePageExperiences } from '../../lib/globalHelper';

// Home page navigation tab selection
const homeNavUserTab = ['personal', 'business', 'technical'];
const TECHNICAL = 'technical';

class NavHome extends Component {
  // To controll navigation tab by remote config; filter the technical selection
  static userTabs() {
    return getHomePageExperiences(homeNavUserTab).filter((tab) => !(tab === TECHNICAL && !Page.hasTechnicalTab()));
  }

  render() {
    if (!Page.checkPageInPath(this.props.pathname)) {
      return null;
    }
    const expTabs = NavHome.userTabs();

    if (Array.isArray(expTabs) && expTabs.length) {
      // Updating the expereiences if country is enabled based in cc3merchantmigration remoteconfig
      this.props.switchContentToggle(expTabs[0]);
    }
    return (
      <div className="nav-home-container">
        {Page.isToggleTreatment() ? <ContentToggle userExpClass={expTabs} /> : <NavDropDown />}
      </div>
    );
  }
}

// NavHome Props Types
NavHome.propTypes = {
  pathname: PropTypes.string,
  switchContentToggle: PropTypes.func.isRequired,
};

// NavHome Props default values
NavHome.defaultProps = {
  pathname: '',
};

// Get the Store data and Pass it as Props.
function mapStateToProps(state) {
  return {
    pathname: state.location.pathname,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ switchContentToggle }, dispatch);
}

// export default NavHome;
export default connect(mapStateToProps, mapDispatchToProps)(NavHome);
